import {
  REQUESTTIME_FETCHING,
  REQUESTTIME_SUCCESS,
  REQUESTTIME_FAILED,
  REQUESTTIME_WITHDRAW_FETCHING,
  REQUESTTIME_WITHDRAW_SUCCESS,
  REQUESTTIME_WITHDRAW_FAILED,
  REQUESTTIME_REASON_FETCHING,
  REQUESTTIME_REASON_FAILED,
  REQUESTTIME_REASON_SUCCESS,
  OVERTIME_36HOURS_FETCHING,
  OVERTIME_36HOURS_FAILED,
  OVERTIME_36HOURS_SUCCESS,
  OVERTIME_36HOURS_DETAIL_FETCHING,
  OVERTIME_36HOURS_DETAIL_FAILED,
  OVERTIME_36HOURS_DETAIL_SUCCESS,
  SETTING_OT_FETCHING,
  SETTING_OT_FAILED,
  SETTING_OT_SUCCESS
} from "./types";

import RequestTimeService from "../services/requestTime.service";

export const getAllRequestTimeById = (search) => async (dispatch) => {
  try {
    const res = await RequestTimeService.getAllRequestTimeById(search);
    if (res) {
      dispatch({
        type: REQUESTTIME_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: REQUESTTIME_FAILED,
    });
    console.log(err);
  }
};

export const getAllRequestTimeBy = (filter, search) => async (dispatch) => {
  try {
    dispatch({
      type: REQUESTTIME_FETCHING,
    });
    const res = await RequestTimeService.getAllRequestTimeBy(filter, search);
    if (res) {
      dispatch({
        type: REQUESTTIME_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: REQUESTTIME_FAILED,
    });
    console.log(err);
  }
};

export const getAllRequestTimeWithDrawBy =
  (filter, search) => async (dispatch) => {
    try {
      dispatch({
        type: REQUESTTIME_WITHDRAW_FETCHING,
      });
      const res = await RequestTimeService.getAllRequestTimeWithDrawBy(
        filter,
        search
      );
      if (res) {
        dispatch({
          type: REQUESTTIME_WITHDRAW_SUCCESS,
          payload: res.data,
        });
      }
    } catch (err) {
      dispatch({
        type: REQUESTTIME_WITHDRAW_FAILED,
      });
      console.log(err);
    }
  };

export const getAllRequestOTBy = (filter, search) => async (dispatch) => {
  try {
    dispatch({
      type: REQUESTTIME_FETCHING,
    });
    const res = await RequestTimeService.getAllRequestOTBy(filter, search);
    if (res) {
      dispatch({
        type: REQUESTTIME_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: REQUESTTIME_FAILED,
    });
    console.log(err);
  }
};

export const getAllRequestTimeCompany =
  (filter, search) => async (dispatch) => {
    try {
      const res = await RequestTimeService.getAllRequestTimeCompany(
        filter,
        search
      );
      if (res) {
        dispatch({
          type: REQUESTTIME_SUCCESS,
          payload: res.data,
        });
      }
    } catch (err) {
      dispatch({
        type: REQUESTTIME_FAILED,
      });
      console.log(err);
    }
  };

export const addRequestTime = (formData) => async () => {
  try {
    const res = await RequestTimeService.addRequestTime(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    console.log(error.response);
    if (error.response) {
      return error.response.data;
    }
  }
};

export const approveRequestTime = (filter, formData) => async () => {
  try {
    const res = await RequestTimeService.approveRequestTime(filter, formData);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const withdrawRequestTime = (formData) => async () => {
  try {
    const res = await RequestTimeService.withdrawRequestTime(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const withdrawConfirmRequestTime = (formData) => async () => {
  try {
    const res = await RequestTimeService.withdrawConfirmRequestTime(formData);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const updateRequestTime = (data) => async () => {
  try {
    const res = await RequestTimeService.updateRequestTime(data);
    if (res) {
      return res;
    }
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
  }
};

export const getRequestReason = (idCompany) => async (dispatch) => {
  try {
    dispatch({
      type: REQUESTTIME_REASON_FETCHING,
    });
    const res = await RequestTimeService.getRequestReason(idCompany);
    if (res) {
      dispatch({
        type: REQUESTTIME_REASON_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: REQUESTTIME_REASON_FAILED,
    });
    console.log(err);
  }
};

export const getVendorRequestReason = (idVendor) => async (dispatch) => {
  try {
    dispatch({
      type: REQUESTTIME_REASON_FETCHING,
    });
    const res = await RequestTimeService.getVendorRequestReason(idVendor);
    if (res) {
      dispatch({
        type: REQUESTTIME_REASON_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: REQUESTTIME_REASON_FAILED,
    });
  }
};

export const addRequestReason = (data) => async () => {
  try {
    const res = await RequestTimeService.addRequestReason(data);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const updateRequestReason = (data) => async () => {
  try {
    const res = await RequestTimeService.updateRequestReason(data);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const deleteRequestReason = (idRequestReason) => async () => {
  try {
    const res = await RequestTimeService.deleteRequestReason(idRequestReason);
    if (res) {
      return res;
    }
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error";
  }
};

export const getOvertime36Hours = (searchDate) => async (dispatch) => {
  try {
    dispatch({
      type: OVERTIME_36HOURS_FETCHING,
    });
    const res = await RequestTimeService.getOvertime36Hours(searchDate);    
    if (res) {
      dispatch({
        type: OVERTIME_36HOURS_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: OVERTIME_36HOURS_FAILED,
    });
    console.log(err);
  }
};

export const getOvertime36HoursDetail = (query) => async (dispatch) => {
  try {
    dispatch({
      type: OVERTIME_36HOURS_DETAIL_FETCHING,
    });
    console.log(query)
    const res = await RequestTimeService.getOvertime36HoursDetail(query);
    if (res) {
      dispatch({
        type: OVERTIME_36HOURS_DETAIL_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: OVERTIME_36HOURS_DETAIL_FAILED,
    });
    console.log(err);
  }
};

export const getMonthlyOvertime = async (query) => {
  try {
    const res = await RequestTimeService.getMonthlyOvertime(query);
    if (res) {
      return res;
    };
  } catch (error) {
    console.error(error);
  };
};

// คืนค่ารายชื่อพนักงาน OT เกิน 36 ชม. โดยตรง (ไม่ผ่าน redux) ใช้ใน popup overview/overtime
export const getOvertime36HoursList = async (query) => {
  try {
    const res = await RequestTimeService.getOvertime36Hours(query);
    if (res && res.data) {
      return res.data;
    }
  } catch (error) {
    console.error(error);
  }
  return [];
};

export const getMonthlyOvertimeDetail = async (query) => {
  try {
    console.log('otD',query)
    const res = await RequestTimeService.getMonthlyOvertimeDetail(query);
    if (res) {
      return res;
    };
  } catch (error) {
    console.error(error);
  };
};

export const getSettingStepTime = (query) => async (dispatch) => {
  try {
    dispatch({
      type: SETTING_OT_FETCHING,
    });
    const res = await RequestTimeService.getSettingStepTime(query);
    if (res) {
      dispatch({
        type: SETTING_OT_SUCCESS,
        payload: res.data,
      });
    };
  } catch (error) {
    dispatch({
      type: SETTING_OT_FAILED,
    });
  };
}

export const addAndUpdateSettingStepTime = async (data) => {
  try {
    const res = await RequestTimeService.addAndUpdateSettingStepTime(data);
    if (res) {
      return res;
    };
  } catch (error) {
    console.error(error);
  };
}